import { AssemblyHeaderRow } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'

export const selectedBomItemsSelector = (state: RootAppState) => {
  return state.project.selectedBomItemIds.map(
    (id) => state.project.flatView[id] || state.project.treeView[id]
  )
}

export const selectedBomItemsIds = (state: RootAppState) => {
  return state.project.selectedBomItemIds
}

export const allFilteredBomItemsSelector = (state: RootAppState) => {
  return state.project.selectedHeaderIds?.reduce((acc, id) => {
    const assembly = state.project.flatView[id] as AssemblyHeaderRow
    if (assembly) {
      return [
        ...acc,
        ...assembly.filteredPartTypeIds.map((x) => state.project.flatView[x]),
      ]
    }
    return acc
  }, [])
}
